import { Component, OnInit } from '@angular/core';
import { NotificationService } from '../../api/services/notification.service';
import { Notification } from '../../api/models/notification';
import { HeaderService } from '../header/header.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { NotificationsPreferencesComponent } from '../notifications-preferences/notifications-preferences.component';

@Component({
  selector: 'app-notifications',
  templateUrl: './notifications.component.html',
  styleUrls: ['./notifications.component.scss']
})
export class NotificationsComponent implements OnInit {

  icon = '&#xe902';
  allNotifications: Notification[] = [];
  notificationsFiltered: any[];
  dateGroups: any[];
  noNotifications: boolean = false;
  loading = true;
  isTask = false;
  showSettings = false;
  page = 1;
  pageSize = 50;
  itemsToShow:any[];
  infoMsg = ['There are no notifications']

  constructor(private notificationService: NotificationService,
    private headerService: HeaderService,
    private modalService: NgbModal
  ) { }

  dismissNotifications(date: string) {
    this.loading = true;
      this.notificationService.updateNotificationByDate(date).subscribe((notifications) => {
        this.allNotifications = notifications;
        this.noNotifications = this.allNotifications.length === 0;
        this.groupNotificationsByDate(this.allNotifications);
        this.headerService.refreshNotificationsBadge();
        this.loading = false;
      });
  }

  dismissNotification(id: string) {
    const notificationId = this.allNotifications.find(a => a.id === id).id;
    this.notificationService.updateNotificationById(notificationId).subscribe(() => {
      this.allNotifications = this.allNotifications.filter(n => n.id !== id);
      this.groupNotificationsByDate(this.allNotifications);
      this.headerService.refreshNotificationsBadge();
    });
  }

  groupNotificationsByDate(notificationList: Notification[]) {
    const hash = {};
    notificationList.forEach(notification => {
      if (notification.notificationDefinitionCode === 'TASK_CREATED'){
        notification.isTask = true;
      }
      const key = new Date(notification.createDateTime).toDateString();
      if (hash[key]) {
        hash[key].push(notification);
      } else {
        hash[key] = [notification];
      }
    });
    this.notificationsFiltered = Object.entries(hash);
    this.notificationsFiltered.sort((a, b) => {
      return new Date(a[0]) > new Date(b[0]) ?
        -1 : new Date(a[0]) < new Date(b[0]) ? 1 : 0;
    });
  }

  openPreferences() {
    this.modalService.open(NotificationsPreferencesComponent, {
      size: 'lg',
      backdrop: 'static',
      keyboard: false
    });
  }

  getDate(notificationDate: string) {
    return new Date(notificationDate);
  }

  loadNotifications() {
    this.loading = true;
    this.notificationService.findNotificationNotUserAcknowledged().subscribe(notifications => {
      this.allNotifications = notifications;
      this.noNotifications = this.allNotifications.length === 0;
      this.headerService.refreshNotificationsBadge();
      this.groupNotificationsByDate(this.allNotifications);
      this.loading = false;
    });
  }

  ngOnInit() {
    this.loadNotifications();
    this.showSettings = true;
  }

  loadPage(page) {
    const from = (page - 1) * this.pageSize;
    const to = from + this.pageSize;
    this.itemsToShow = this.allNotifications.slice(from, to);
    this.groupNotificationsByDate(this.itemsToShow);
    this.loading = false;
  }
}



// WEBPACK FOOTER //
// /codebuild/output/src3408204168/src/bitbucket.org/tesscotds/webclient/src/app/notifications/notifications.component.ts